import { useQuery } from '@tanstack/react-query';
import { getBookingImages } from '../api/bookingImagesApi';
import { useAuthStore } from '../../auth/stores/authStore';

export const bookingImageKeys = {
  all: ['bookingImages'] as const,
  images: (allocationId: string, isAuthenticated: boolean) =>
    [...bookingImageKeys.all, { allocationId, isAuthenticated }] as const,
};

export function useBookingImages(allocationId: string | null) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: bookingImageKeys.images(allocationId || '', isAuthenticated),
    queryFn: () => getBookingImages(allocationId!),
    enabled: isAuthenticated && !!allocationId,
    staleTime: 5 * 60 * 1000,
  });
}
